<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_ix"></a><a id="ack"></a></p>
<h2 class="h2a">Acknowledgments</h2>
<p class="noindent1">I suppose I’ve been working on this book as long as I’ve been interested in dreams. So I really have to thank <em>everybody</em>—all the teachers, colleagues, and students who helped and guided me along the way. Several people have contributed directly to this project in quite valuable ways, so I wish to express special gratitude to Serinity Young, Madhu Tandan, Lewis Rambo, Bill Domhoff, Kimberley Patton, Bart Koet, Lee Irwin, Dimitris Xygalatas, Roger Knudson, Ernest Hartmann, Jeremy Taylor, Tracey Kahan, Justina Lasley, Ryan Hurd, Nina Azari, David Kahn, Kasia Szpakowska, Patricia Davis, Kate Adams, Malek Yamani, Jeff Kripal, Eleanor Rosch, Mark Fagiano, Lily Wu, Lana Nasser, Celeste Newbrough, and the anonymous reader who reviewed earlier drafts. I’m also grateful for the patient encouragement of my editor, Jennifer Hammer, and for the professional work of the production staff of New York University Press.<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?7fc3e971